<template>
  <div class="card">
    <div class="content">
      <div>
        <div style="padding-top:20px; min-height: 325px;">
          <slot name="video-link-thumb"></slot>
          <div style="text-align:center;">
            <slot name="title"></slot>
          </div>
        </div>
        </div>
      </div>
      <div style="padding:0px 20px 20px 20px; text-align: center;">
        <button v-if="!loading" class="btn btn-default btn-fill btn-wd" @click="confirmReviewRemove()">Remove</button>
        <button type="button" v-if="loading" class="btn btn-default" disabled="disabled">
          <span class="btn-label">
            <i class="fa fa-circle-o-notch fa-spin"></i>
          </span>
          Remove
        </button>
      </div>
    </div>
  
  </div>
</template>
<script>
  import axios from 'axios'
  import swal from 'sweetalert2'
  import store from '@/store'

  export default {
    name: 'review-card',
    props: ['ReviewId', 'review'],
    data () {
      return {
        axios_config: {
          headers: {
            'Content-Type': 'application/json',
            Authorization: ''
          },
          responseType: 'text'
        },
        remove_review_body: {
          product_id: this.review.product_id,
          reviewer_email: this.review.reviewer_email
        },
        loading: false
      }
    },
    methods: {
      confirmReviewRemove () {
        this.loading = true
        swal({
          title: 'Are you sure?',
          text: `Only videos that are in direct conflict or offensive according to our “Community Guidelines” may be removed by the account admin. Deleted videos are forever erased from our database and can not be retrieved at a later time.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, remove it!',
          buttonsStyling: false
        }).then(() => {
          this.removeReview()
        }).catch(() => {
          this.loading = false
        })
      },
      removeReview () {
        this.$cognitoAuth.isAuthenticatedWithAttributes((err, response) => {
          if (err) {
            console.log(err)
            this.$router.replace('/login')
          } else if (!response) {
            this.user = false
            this.loggedIn = false
            this.$router.replace('/login')
          } else {
            console.log('getIdToken')
            this.$cognitoAuth.getIdToken((err, response) => {
              if (err) {
                console.log('error:')
                console.log(err)
                this.loading = false
              } else {
                console.log('got new id token')
                console.log(response)
                this.axios_config.headers.Authorization = 'Bearer ' + response
                console.log(this.axios_config)

                // let userId = store.getUser().id
                let endpoint = 'https://ppe-locator.com'
                console.log('posting to ' + endpoint)
                axios.post(endpoint, this.remove_review_body, this.axios_config)
                .then((response) => {
                  this.loading = false
                  console.log('review removed')
                  this.$emit('remove')
                  swal({
                    title: 'Removed!',
                    text: 'The review was successfully removed.',
                    type: 'success',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    buttonsStyling: false
                  })
                })
                .catch(function (error) {
                  this.loading = false
                  console.log(error)
                  swal({
                    title: 'Error',
                    text: error.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                  })
                })
              }
            })
          }
        })
      }
    }
  }

</script>
<style>
  
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/ReviewCard.vue